import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useRefferalData = () => {
  return useAPIQuery(
    DefaultsApi,
    ["refferalDropDownData"],
    async (api) => {
      const response = await api.defaultsGetReferralList();

      return response;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
